import { useStrings } from "@1js/localization-components";
import { PromptLibraryCloseButton } from "@1js/pl-card-components";
import { Button, Text } from "@fluentui/react-components";
import parse from "html-react-parser";
import * as React from "react";
import { useState } from "react";
import useTelemetry from "../../utils/Telemetry/useTelemetry";
import {
  SignIn,
  SignInButtonLabel,
  SignInHeaderV2,
} from "./SignInHeader.web.string";
import { SignInHeaderNavStyles } from "./SignInHeaderNav.styles";

const useStyles = SignInHeaderNavStyles;

const returnLink = encodeURIComponent(window.location.href);
const link = `https://${window.location.host}/authentication/signin?ru=${returnLink}`;

export const SignInHeaderNav: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const styles = useStyles();
  const telemetry = useTelemetry();
  const [isVisible, setIsVisible] = useState(true);
  const localizations = useStrings({
    SignIn,
    SignInHeaderV2,
    SignInButtonLabel,
  });
  const handleClose = () => {
    setIsVisible(false);
    onClose(); // Call the onClose function
  };
  const handleClick = () => {
    telemetry.sendSignInSuggestionHeaderClickEvent();
  };

  return (
    <>
      {isVisible && (
        <>
          <div className={styles.main} data-testid="sign-in-header">
            <Text className={styles.text}>
              {parse(localizations.SignInHeaderV2())}
            </Text>
            <Button
              className={styles.button}
              data-testid="sign-in-button"
              size={"small"}
              appearance={"secondary"}
              as="a"
              onClick={handleClick}
              href={link}
              aria-label={localizations.SignInButtonLabel()}
            >
              <Text className={styles.buttonText}>
                {parse(localizations.SignIn())}
              </Text>
            </Button>
          </div>
          <PromptLibraryCloseButton
            data-testid="close-button"
            onClick={handleClose}
          />
        </>
      )}
    </>
  );
};
